import React from 'react'
import AddCustomerContainer from '../../../../../Components/UserPart/AddUser/AddCustomerContainer/AddCustomerContainer'
import Layout from '../../../Layout'

const AddCustomer= () => {
  return (
    <Layout>
        <AddCustomerContainer/>
    </Layout>
  )
}

export default AddCustomer